(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ScoreController', ScoreController);

    ScoreController.$inject = ['Score'];

    function ScoreController(Score) {

        var vm = this;

        vm.scores = [];

        loadAll();

        function loadAll() {
            Score.query(function(result) {
                vm.scores = result;
                vm.searchQuery = null;
            });
        }
    }
})();
